import { Validators, FormControl, FormGroup } from "@angular/forms";

export function truncate(str: string, n: number) {
  return str.length > n ? str.slice(0, n - 1) + "&hellip;" : str;
}

export class CommonFunction {
  static customSTMBRound(num: number): number {
    const decVal = parseFloat((num % 1).toFixed(2)); // Get 2 decimal point
    const decSubVal = parseFloat((num % 1).toFixed(2).substring(0, 3)); // Get 1 decimal point

    if (
      decVal >= parseFloat((decSubVal + 0.01).toFixed(2)) &&
      decVal <= parseFloat((decSubVal + 0.02).toFixed(2))
    ) {
      return Math.floor(num) + decSubVal;
    } else if (
      decVal >= parseFloat((decSubVal + 0.03).toFixed(2)) &&
      decVal <= parseFloat((decSubVal + 0.05).toFixed(2))
    ) {
      return Math.floor(num) + (decSubVal + 0.05);
    } else if (
      decVal >= parseFloat((decSubVal + 0.06).toFixed(2)) &&
      decVal <= parseFloat((decSubVal + 0.07).toFixed(2))
    ) {
      return Math.floor(num) + (decSubVal + 0.05);
    } else if (
      decVal >= parseFloat((decSubVal + 0.08).toFixed(2)) &&
      decVal <= parseFloat((decSubVal + 0.09).toFixed(2))
    ) {
      return Math.floor(num) + (decSubVal + 0.1);
    } else {
      return num;
    }
  }

  static createBannerControls(bannerTypes: any[]): { [key: string]: any } {
    const group: { [key: string]: any } = {};

    bannerTypes.forEach((banner) => {
      group[banner.controlName] = [[], Validators.required];
    });

    return group;
  }

  static combineDateTimeToUTCString(
    date: string,
    time: string,
    isEndDate: boolean = false
  ): string {
    const [timePart, modifier] = time.split(" ");
    let [hours, minutes] = timePart.split(":").map(Number);

    if (modifier === "PM" && hours < 12) hours += 12;
    if (modifier === "AM" && hours === 12) hours = 0;

    const dateObj = new Date(date);

    // Extract the time zone offset in minutes from the current time zone
    const tzOffset = dateObj.getTimezoneOffset(); // Offset in minutes

    // Set the hours and minutes for the time, ensuring to handle time zone offsets
    dateObj.setHours(hours, minutes, isEndDate ? 59 : 0, 0);

    // Convert the date to UTC based on the original date's time zone offset
    const utcTime = new Date(dateObj.getTime() - tzOffset * 60 * 1000);

    return utcTime.toUTCString();
  }

  static convertToGMTPlus8(dateStr: string): string {
    const date = new Date(dateStr);

    // Adjust for GMT+08:00 timezone
    // date.setHours(date.getHours() + 8);

    // Convert to ISO string and replace "Z" with "+08:00" for the correct timezone format
    return date.toISOString().replace("Z", "+08:00");
  }

  static isValidISOWithOffset(value: string): boolean {
    const isoOffsetRegex =
      /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}[+-]\d{2}:\d{2}$/;

    if (!isoOffsetRegex.test(value)) return false;

    const date = new Date(value);
    return !isNaN(date.getTime());
  }

  static toLocalTimeString(date: Date): string {
    // you can tweak locale and options as needed
    return date.toLocaleTimeString(undefined, {
      hour: "2-digit",
      minute: "2-digit"
    });
  }
}
